import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark" | "system";

interface ThemeStore {
  theme: Theme;
  resolvedDark: boolean;
  setTheme: (theme: Theme) => void;
}

function resolveIsDark(theme: Theme): boolean {
  if (theme === "dark") return true;
  if (theme === "light") return false;
  return typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function applyThemeClass(theme: Theme): void {
  const isDark = resolveIsDark(theme);
  document.documentElement.classList.toggle("dark", isDark);
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      theme: "system" as Theme,
      resolvedDark: false,
      setTheme: (theme) => {
        const resolvedDark = resolveIsDark(theme);
        applyThemeClass(theme);
        set({ theme, resolvedDark });
      },
    }),
    { name: "theme-preferences" },
  ),
);

/** Inicializar al cargar: aplicar tema guardado y escuchar cambios del sistema */
export function initTheme(): void {
  const { theme } = useThemeStore.getState();
  applyThemeClass(theme);

  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    if (useThemeStore.getState().theme === "system") {
      applyThemeClass("system");
      useThemeStore.setState({ resolvedDark: resolveIsDark("system") });
    }
  });
}
